/**
 * Footer — four-column design matching the Faircast brand.
 * Links are wired to real routes where they exist; placeholder (#) where not yet built.
 */
function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="fc-footer">
      <div className="fc-wrap">
        <div className="fc-footer-grid">
          {/* Brand */}
          <div className="fc-footer-brand">
            <a href="/" className="fc-brand">
              <span className="fc-brand-mark" aria-hidden="true"></span>
              <span className="fc-brand-name">Faircast</span>
            </a>
            <p className="fc-footer-blurb">
              Dansk podcast-platform. 30 kr/md. 80% af hver krone går til skaberen. Det er vel fair nok?
            </p>
          </div>

          {/* Product */}
          <div className="fc-footer-col">
            <h5>Produkt</h5>
            <a href="/subscribe">Lyt</a>
            <a href="/for-creators">For skabere</a>
            <a href="/subscribe">Priser</a>
            <a href="/podcast/import">Importer RSS</a>
          </div>

          {/* Firma */}
          <div className="fc-footer-col">
            <h5>Firma</h5>
            <a href="/about">Om os</a>
            <a href="/#promises">Principper</a>
            <a href="#">Det åbne regnskab</a>
            <a href="#">Presse</a>
          </div>

          {/* Juridisk */}
          <div className="fc-footer-col">
            <h5>Juridisk</h5>
            <a href="#">Vilkår</a>
            <a href="#">Privatliv</a>
            <a href="#">Cookies</a>
            <a href="#">Kontakt</a>
          </div>
        </div>

        <div className="fc-footer-bottom">
          <div>© {year} Faircast ApS · København</div>
          <div className="fc-footer-locale">
            <span>🇩🇰 Dansk</span>
            <span>DKK</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
